export default [
  {
    path: "/channels",
    name: "channels",
    icon: "share-2",
    component: () => import("@/views/Channels/ChannelsList.vue"),
    meta: {
      title: "Channels",
      ability: { action: "read", subject: "Enforcement" },
    },
  },
];
